// {
// 				"id": "5f458ee8-048a-42d6-b86d-bfa04d62dbc1",
// 				"refTable": "SaleOrders",
// 				"refId": "921ceb22-58e9-43fb-b0d0-9eb426186022",
// 				"ownerType": "CUSTOMER",
// 				"ownerId": "b1a0c485-51b8-431a-8a4b-81ceba636c3e",
// 				"type": "INCOME",
// 				"transactionAmount": "150.00",
// 				"transactionMethodId": "1c73ded0-c116-4d7e-98d9-1efdc86e9f2f",
// 				"createdAt": "2025-08-02T20:55:38.986Z",
// 				"updatedAt": "2025-08-02T20:55:38.986Z",
// 				"deletedAt": null

import { TransactionMethod } from './TransactionMethod';
export enum ETransType {
  Income = 'INCOME',
  Outcome = 'OUTCOME',
  Deposit = 'DEPOSIT',
  OS_EXTRA_FEE = 'OS_EXTRA_FEE',
}
// 			},
export interface Transaction {
  id: string;
  refTable: 'SaleOrders' | 'InventoryDocuments';
  refId: string;
  ownerType: 'CUSTOMER' | 'SUPPLIER';
  ownerId: string;
  type: ETransType;
  transactionAmount: number;
  transactionMethodId: string;
  transactionMethod?: TransactionMethod;
  warehouseId?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
}
